export const loginConstants = {
    LOGIN_FAILURE: "LOGIN_FAILURE",
    LOGIN_SUCCESS: "LOGIN_SUCCESS",

    LOGOUT_FAILURE: "LOGOUT_FAILURE",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
}